<script setup lang="ts">
import { format as formatFunc, isValid} from 'date-fns'

const props = defineProps({
  date: {
    type: Date,
    default: '',
  },
  format: {
    type: String,
    default: 'dd-MM-yyyy',
  },
})

const formatDate = (date: any) => {
  if (!isValid(date)) {
    return '00-00-0000'
  }
  return formatFunc(date, props.format)
}
</script>
<template>
  {{ formatDate(props.date) }}
</template>
